import { gql } from "@apollo/client";

export const GET_LABEL_RULE_GROUPS_V3 = gql`
  query GetLabelRuleGroupsV3 {
    me {
      labelRuleGroupsV3 {
        id
        name
        active
        isUsingSimpleUI
        createdAt
        updatedAt
        segments
        updatedBy
      }
    }
  }
`;

export const GET_LABEL_RULES_BY_GROUP_V3 = gql`
  query GetLabelRulesByGroupV3($id: String!) {
    me {
      labelRulesByGroupV3(id: $id) {
        id
        groupId
        name
        level
        active
        isUsingSimpleUI
        createdAt
        updatedAt
        labelRule {
          name
          active
          output
          priority
          createdAt
          matcher
          _metadata
        }
      }
    }
  }
`;

export const GET_LABEL_WIZARD_DATA_V3 = gql`
  query GetLabelWizardDataV3 {
    me {
      labelFiltersV3 {
        id
        labelKey
        labelValue
        matcher
      }
      labelRuleGroupsV3 {
        name
      }
    }
  }
`;

export const CREATE_LABEL_RULE_GROUP_V3 = gql`
  mutation CreateLabelRuleGroupV3(
    $campaignLabelRule: LabelRuleV3Input
    $adsetLabelRule: LabelRuleV3Input
    $adLabelRule: LabelRuleV3Input
  ) {
    createLabelRuleGroupV3(
      campaignLabelRule: $campaignLabelRule
      adsetLabelRule: $adsetLabelRule
      adLabelRule: $adLabelRule
    ) {
      id
      name
      active
      isUsingSimpleUI
      createdAt
      updatedAt
      segments
    }
  }
`;

export const UPDATE_LABEL_RULE_GROUP_V3 = gql`
  mutation UpdateLabelRuleGroupV3(
    $id: String!
    $campaignLabelRule: LabelRuleV3Input
    $adsetLabelRule: LabelRuleV3Input
    $adLabelRule: LabelRuleV3Input
  ) {
    updateLabelRuleGroupV3(
      id: $id
      campaignLabelRule: $campaignLabelRule
      adsetLabelRule: $adsetLabelRule
      adLabelRule: $adLabelRule
    ) {
      id
      name
      active
      isUsingSimpleUI
      createdAt
      updatedAt
      segments
    }
  }
`;

export const PATCH_LABEL_RULE_GROUP_V3 = gql`
  mutation PatchLabelRuleGroupV3(
    $id: String!
    $active: Boolean
    $isUsingSimpleUI: Boolean
  ) {
    patchLabelRuleGroupV3(
      id: $id
      active: $active
      isUsingSimpleUI: $isUsingSimpleUI
    ) {
      id
      name
      active
      isUsingSimpleUI
      createdAt
      updatedAt
      segments
    }
  }
`;

export const DUPLICATE_LABEL_RULE_GROUP_V3 = gql`
  mutation DuplicateLabelRuleGroupV3($id: String!, $isUsingSimpleUI: Boolean!) {
    duplicateLabelRuleGroupV3(id: $id, isUsingSimpleUI: $isUsingSimpleUI) {
      id
      name
      active
      isUsingSimpleUI
      createdAt
      updatedAt
      segments
    }
  }
`;

export const DELETE_LABEL_RULE_GROUP_V3 = gql`
  mutation DeleteLabelRuleGroupV3($id: String!) {
    deleteLabelRuleGroupV3(id: $id) {
      id
      name
      active
      isUsingSimpleUI
      createdAt
      updatedAt
      segments
    }
  }
`;

export const PREVIEW_LABEL_RULE_MATCHES = gql`
  query PreviewLabelRuleMatches(
    $level: String
    $search: String
    $matcherSearch: JSONObject
    $labelRules: [JSONObject!]!
  ) {
    me {
      id
      previewLabelRuleMatches(
        level: $level
        search: $search
        matcherSearch: $matcherSearch
        labelRules: $labelRules
      )
    }
  }
`;
